module.exports = __webpack_public_path__ + "static/media/fanhub-logo.bef7e41d.svg";